<template>
  <div class="card shadow-sm mt-4">
    <div class="card-body">
      <div class="section-heading pb-3">Last 30 days</div>

      <div v-if="loading" class="text-center py-2">
        <i class="fas fa-spinner fa-spin fa-1x"></i>
      </div>

      <canvas ref="visitorChart" height="100"></canvas>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
import axios from "axios";

export default {
  props: ["site_id"],

  data() {
    return {
      chart: null,
      visitorsData: [],
      loading: true,
    };
  },

  created() {
    this.getData();

    Echo.channel("site_" + this.site_id).listen("SiteVisitor", () => {
      this.getData();
    });
  },

  methods: {
    getData() {
      axios
        .post(`/websites/graph`, { site_id: this.site_id })
        .then((response) => {
          this.visitorsData = response.data;
          this.renderChart();
        })
        .catch((error) => {
          this.sweetfire(error.response.data.message);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    renderChart() {
      const labels = this.visitorsData.map((item) => item.date);
      const data = this.visitorsData.map((item) => Number(item.visitors));

      let minValue = Math.min(...data);
      let maxValue = Math.max(...data);
      maxValue = 5 * Math.floor(maxValue / 5 + 1);
      minValue = Math.max(0, minValue - 5);

      if (this.chart) {
        // Update existing chart
        this.chart.data.labels = labels;
        this.chart.data.datasets[0].data = data;
        this.chart.options.scales.y.min = minValue;
        this.chart.options.scales.y.max = maxValue;
        this.chart.update();
      } else {
        // Create chart for the first time
        const ctx = this.$refs.visitorChart.getContext("2d");
        this.chart = new Chart(ctx, {
          type: "line",
          data: {
            labels,
            datasets: [
              {
                label: "Visitors",
                data,

                // line
                borderColor: "rgba(54, 162, 235, 1)",
                // borderColor: "rgba(0, 0, 0, 1)",
                borderWidth: 2,
                tension: 0,
                pointRadius: 3,
                pointBackgroundColor: "rgba(54, 162, 235, 1)",
                // pointBackgroundColor: "rgba(0, 0, 0, 1)",
                backgroundColor: "rgba(200, 200, 200, 0.3)", // Shading below the line
                fill: true, // Enable shading

                // bar
                // backgroundColor: "rgba(54, 162, 235, 1)",
                // borderColor: "rgba(54, 162, 235, 1)",
              },
            ],
          },
          options: {
            responsive: true,
            interaction: {
              mode: "index",
              intersect: false,
            },
            plugins: {
              legend: { display: false },
              tooltip: {
                displayColors: false,
                callbacks: {
                  title: (tooltipItems) => {
                    const rawLabel = tooltipItems[0].label; // "14 Sep 2025"
                    const date = new Date(rawLabel);

                    const weekday = date.toLocaleDateString("en-GB", {
                      weekday: "short",
                    }); // Sun
                    const day = date.getDate(); // removes leading zero
                    const month = date.toLocaleDateString("en-GB", {
                      month: "short",
                    }); // Sep
                    const year = date.getFullYear(); // 2025

                    return `${weekday} ${day} ${month} ${year}`;
                  },
                  label: (tooltipItem) => {
                    return `${tooltipItem.formattedValue} visitors`;
                  },
                },
              },
            },
            scales: {
              y: {
                ticks: { precision: 0, stepSize: 5 },
                min: minValue,
                max: maxValue,
                grid: { display: true },
              },
              x: {
                grid: { display: false },
                ticks: {
                  callback: function (value, index) {
                    return index !== 0 && index % 3 === 0
                      ? this.getLabelForValue(value)
                      : "";
                  },
                  maxRotation: 0,
                  minRotation: 0,
                },
              },
            },
          },
        });
      }
    },
  },

  beforeDestroy() {
    if (this.chart) {
      this.chart.destroy();
    }
  },
};
</script>
